import './preloader.scss';

export default () => {
	$( '.preloader img' ).on( 'animationend', function () {
		$( this ).closest( '.preloader' ).hide();
	} );
};
